import { render, staticRenderFns } from "./open-module.vue?vue&type=template&id=54736362&scoped=true&"
import script from "./open-module.vue?vue&type=script&lang=js&"
export * from "./open-module.vue?vue&type=script&lang=js&"
import style0 from "./open.scss?vue&type=style&index=0&id=54736362&lang=scss&scoped=true&"
import style1 from "./open-module.vue?vue&type=style&index=1&id=54736362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54736362",
  null
  
)

export default component.exports